import { FC } from 'react';
import styled from 'styled-components';
import { isToday } from '../../utils/isToday';

interface DateHeaderProps {
  date: Date;
}

const Container = styled.span(({ theme }) => {
  const { color, type } = theme.new;

  return `
    display: flex;
    flex-flow: column nowrap;
    justify-content: center;
    align-items: center;
    font-family: ${type.face};
    background-color: ${color.neutral[3]};
    color: ${color.shade[2]};
    font-size: ${type.size[12]};
    line-height: 1.125rem;
    letter-spacing: 0.015rem;
    border-radius: 6px;
    padding: 0.125rem 0.5rem;

    &.currentDate {
      background-color: ${color.shade[2]};
      color: ${color.shade[1]};
    }
  `;
});

const Day = styled.span(({ theme }) => {
  const { type } = theme.new;

  return `
    display: block;
    font-weight: ${type.weight.bold};
  `;
});

const Date = styled.span(({ theme }) => {
  const { type } = theme.new;

  return `
    display: block;
    font-weight: ${type.weight.regular};
  `;
});

const getDayLetter = (date: Date): string => {
  switch (date.getDay()) {
    case 0:
    case 6:
      return 'S';
    case 1:
      return 'M';
    case 2:
    case 4:
      return 'T';
    case 3:
      return 'W';
    case 5:
      return 'F';
    default:
      throw Error('Please supply a valid date');
  }
};

const DateHeader: FC<DateHeaderProps> = ({ date }) => {
  return (
    <Container className={isToday(date) ? 'currentDate' : ''}>
      <Day>{getDayLetter(date)}</Day>
      <Date>
        {date.getMonth() + 1}/{date.getDate()}
      </Date>
    </Container>
  );
};

export default DateHeader;
